import CustomRadio from '../../../common/components/CustomRadio';
import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';
import MusicAlbumEditForm3EditPopupViewVersionLiveInput from './MusicAlbumEditForm3EditPopupViewVersionLiveInput';
import MusicAlbumEditForm3EditPopupViewVersionRemixInput from './MusicAlbumEditForm3EditPopupViewVersionRemixInput';

type MusicAlbumEditForm3EditPopupViewVersionInputFieldName =
  'has_version'|'version_type'|'version'|'version_kana'|'version_en'|
  'city'|'city_kana'|'city_en'|'place'|'place_kana'|'place_en'|'year'|'year_kana'|'year_en'|
  'remix_name'|'remix_name_kana'|'remix_name_en'|'remixer_name'|'remixer_name_en';

/**
 * バージョン入力
 */
export default function MusicAlbumEditForm3EditPopupViewVersionInput({
  getValue,
  setValue,
  getErrors,
} : {
  getValue: (name: MusicAlbumEditForm3EditPopupViewVersionInputFieldName) => string,
  setValue: (name: MusicAlbumEditForm3EditPopupViewVersionInputFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm3EditPopupViewVersionInputFieldName) => FieldValidationErrorsType,
}) {
  const hasVersionOptions = [
    { title: 'あり', value: '1' },
    { title: 'なし', value: '0' },
  ];
  const versionTypeOptions = [
    { title: 'Instrumental', value: 'instrumental' },
    { title: 'Off Vocal', value: 'offvocal' },
    { title: 'Karaoke Ver.', value: 'karaoke' },
    { title: 'Acoustic Ver.', value: 'acoustic' },
    { title: 'Live at ～', value: 'live' },
    { title: 'リミックス', value: 'remix' },
    { title: 'その他', description: '自由入力', value: 'other' },
  ];

  return (
    <>
      <dl>
        <dt>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label htmlFor="/">
            バージョン名（Inst、Live、カラオケなど）
          </label>
        </dt>
        <dd>
          <CustomRadio
            options={hasVersionOptions}
            value={getValue('has_version')}
            setValue={(value) => setValue('has_version', value)}
            validationErrors={{}}
          />
        </dd>
      </dl>
      {getValue('has_version') !== '0' && (
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">選択してください</label>
          </dt>
          <dd>
            <CustomRadio
              options={versionTypeOptions}
              value={getValue('version_type')}
              setValue={(value) => setValue('version_type', value)}
              validationErrors={{}}
            />
          </dd>
        </dl>
      )}
      {(getValue('has_version') !== '0' && getValue('version_type') === 'other') && (
        <>
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="/">バージョン表記</label>
            </dt>
            <dd>
              <CustomTextInput
                placeholder="Frekul Release"
                value={getValue('version')}
                setValue={(value) => setValue('version', value)}
                validationErrors={getErrors('version')}
              />
              <p className="text_info_off">ここに説明文</p>
            </dd>
          </dl>
          <dl>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <dt><label htmlFor="/">バージョン表記（ひらがな）</label></dt>
            <dd>
              <CustomTextInput
                placeholder="ふりくる あるばむ"
                value={getValue('version_kana')}
                setValue={(value) => setValue('version_kana', value)}
                validationErrors={getErrors('version_kana')}
              />
              <p className="text_info_off">ここに説明文</p>
            </dd>
          </dl>
          <dl>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <dt><label htmlFor="/">バージョン表記（英語）</label></dt>
            <dd>
              <CustomTextInput
                placeholder="Frekul Release"
                value={getValue('version_en')}
                setValue={(value) => setValue('version_en', value)}
                validationErrors={getErrors('version_en')}
              />
              <p className="text_info_on">「Album」「Single」「Limited」等、販売形式を限定するような表現は使用できません。</p>
            </dd>
          </dl>
        </>
      )}
      {(getValue('has_version') !== '0' && getValue('version_type') === 'remix') && (
        <MusicAlbumEditForm3EditPopupViewVersionRemixInput
          getValue={getValue}
          setValue={setValue}
          getErrors={getErrors}
        />
      )}      
      {(getValue('has_version') !== '0' && getValue('version_type') === 'live') && (
        <MusicAlbumEditForm3EditPopupViewVersionLiveInput
          getValue={getValue}
          setValue={setValue}
          getErrors={getErrors}
        />
      )}
    </>
  );
}
